type RequestConfig = {
  baseUrl: string;
  aiBotBaseUrl: string;
  crmBaseUrl: string;
  crmBaseUrlWL: string;
};

let requestConfig: RequestConfig;

const builderInstance = process.env.REACT_APP_BUILDER_INSTANCE || '6';
const aiInstance = process.env.REACT_APP_AI_INSTANCE || '6';
const apiInstance = process.env.REACT_APP_API_INSTANCE || '6';

if (
  process.env.REACT_APP_ENV === 'production' ||
  process.env.REACT_APP_ENV === 'stagingWithProd'
) {
  requestConfig = {
    baseUrl: 'https://flow-api.doubletick.io',
    aiBotBaseUrl: 'https://aiapi.doubletick.io',
    crmBaseUrl: 'https://api.doubletick.io',
    crmBaseUrlWL: 'https://api.appmix.co',
  };
} else if (process.env.REACT_APP_ENV === 'apiStaging' ) {
  requestConfig = {
    baseUrl: 'https://flow-staging.doubletick.io',
    aiBotBaseUrl: 'https://ai-staging-2.doubletick.io',
    crmBaseUrl: 'https://api-staging-4.doubletick.io',
    crmBaseUrlWL: 'https://api-staging.doubletick.io',
  };
} else {
  requestConfig = {
    baseUrl: `https://builder-${builderInstance}.doubletick.dev`,
    aiBotBaseUrl: `https://ai-${aiInstance}.doubletick.dev`,
    crmBaseUrl: `https://api-${apiInstance}.doubletick.dev`,
    crmBaseUrlWL: `https://api-${apiInstance}.doubletick.dev`,
  };
}

export default requestConfig;
